import * as moment from 'moment';
export class JsonUtilityBody {

    public AttendanceActivityJson(person: any, meeting: any) {
        return {

            "$type": "Asi.Soa.Core.DataContracts.GenericEntityData, Asi.Contracts",
            "Properties": {
                "$type": "Asi.Soa.Core.DataContracts.GenericPropertyDataCollection, Asi.Contracts",
                "$values": [
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "ID",
                        "Value": person.id
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "VisitType",
                        "Value": "SM"
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "Note",
                        "Value": meeting.Note ? String(meeting.Note).substring(0, 21474836) : null                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "Description",
                        "Value": meeting.MeetingTitle
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "MeetingType",
                        "Value": meeting.MeetingType
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "Date",
                        "Value":  moment(meeting.MeetingDate).format('YYYY-MM-DDT00:00:00') 
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "LeadStaff",
                        "Value": meeting.OrganiserId
                    }
                ]
            }
        };
    }

    public MemberAttendanceActivityJson(person: any, meeting: any) {
        return {

            "$type": "Asi.Soa.Core.DataContracts.GenericEntityData, Asi.Contracts",
            "Properties": {
                "$type": "Asi.Soa.Core.DataContracts.GenericPropertyDataCollection, Asi.Contracts",
                "$values": [
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "ID",
                        "Value": person.id
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "Note",
                        "Value": meeting.Note
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "SiteVisitID",
                        "Value": meeting.seqn
                    }
                ]
            }
        };
    }

    public GetAddPartyJson(person: any, meeting: any): any {
        return {
            "$type": "Asi.Soa.Membership.DataContracts.PersonData, Asi.Contracts",
            "PersonName": {
                "$type": "Asi.Soa.Membership.DataContracts.PersonNameData, Asi.Contracts",
                "FirstName": person.firstName,
                "InformalName": "",
                "MiddleName": person.middleName,
                "LastName": person.lastName,
                "FullName": person.firstName + " " + person.middleName + " " + person.lastName,
                "Tollfree": person.mobilePhone
            },
            "PrimaryOrganization": {
                "$type": "Asi.Soa.Membership.DataContracts.PrimaryOrganizationInformationData, Asi.Contracts",
                "OrganizationPartyId": meeting.WorksiteId,
                "Name": meeting.WorkSite
            },
            "AdditionalAttributes": {
                "$type": "Asi.Soa.Core.DataContracts.GenericPropertyDataCollection, Asi.Contracts",
                "$values": [
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "CustomerTypeDescription",
                        "Value": "Prospect"
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "IsMemberRecord",
                        "Value": {
                            "$type": "System.Boolean",
                            "$value": false
                        }
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "CustomerTypeCode",
                        "Value": person.memberType
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "IsMember",
                        "Value": {
                            "$type": "System.Boolean",
                            "$value": false
                        }
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "IsInactiveMember",
                        "Value": {
                            "$type": "System.Boolean",
                            "$value": false
                        }
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "AllowAdvanceRenewal",
                        "Value": {
                            "$type": "System.Boolean",
                            "$value": false
                        }
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "JoinDate",
                        "Value": ""
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "ParentPartyId",
                        "Value": meeting.WorksiteId
                    }
                ]
            },
            "Addresses": {
                "$type": "Asi.Soa.Membership.DataContracts.FullAddressDataCollection, Asi.Contracts",
                "$values": []

            },
            "AlternateIds": {
                "$type": "Asi.Soa.Core.DataContracts.AlternateIdDataCollection, Asi.Contracts",
                "$values": []

            },
            "Emails": {
                "$type": "Asi.Soa.Membership.DataContracts.EmailDataCollection, Asi.Contracts",
                "$values": [
                    {
                        "$type": "Asi.Soa.Membership.DataContracts.EmailData, Asi.Contracts",
                        "Address": person.email,
                        "EmailType": "_Primary",
                        "IsPrimary": true
                    }
                ]
            },
            "Phones": {
                "$type": "Asi.Soa.Membership.DataContracts.PhoneDataCollection, Asi.Contracts",
                "$values": [
                    {
                        "$type": "Asi.Soa.Membership.DataContracts.PhoneData, Asi.Contracts",
                        "Number": "",
                        "PhoneType": "_Home Phone"
                    },
                    {
                        "$type": "Asi.Soa.Membership.DataContracts.PhoneData, Asi.Contracts",
                        "Number": person.mobilePhone,
                        "PhoneType": "Mobile"
                    },
                    {
                        "$type": "Asi.Soa.Membership.DataContracts.PhoneData, Asi.Contracts",
                        "Number": "",
                        "PhoneType": "Work"
                    }
                ]
            },
            "FinancialInformation": {
                "$type": "Asi.Soa.Membership.DataContracts.FinancialInformationData, Asi.Contracts"
            },

            "SocialNetworks": {
                "$type": "Asi.Soa.Membership.DataContracts.PartySocialNetworkDataCollection, Asi.Contracts",
                "$values": []
            },
            "CommunicationTypePreferences": {
                "$type": "Asi.Soa.Membership.DataContracts.PartyCommunicationTypePreferenceDataCollection, Asi.Contracts",
                "$values": []
            },


            "Status": {
                "$type": "Asi.Soa.Membership.DataContracts.PartyStatusData, Asi.Contracts",
                "PartyStatusId": "A",
                "Name": "Active",
                "Description": "Active"
            },
            "Name": person.firstName + " " + person.lastName,
            "Sort": person.lastName + ", " + person.firstName
        };
    }

    public EntityMeetingJson(meeting:any){
        return   {
            "$type": "Asi.Soa.Core.DataContracts.GenericEntityData, Asi.Contracts",
            "EntityTypeName": "i4u_UT_SiteVisits",
            "PrimaryParentEntityTypeName": "Party",
            "Identity": {
                "$type": "Asi.Soa.Core.DataContracts.IdentityData, Asi.Contracts",
                "EntityTypeName": "i4u_UT_SiteVisits",
                "IdentityElements": {
                    "$type": "System.Collections.ObjectModel.Collection`1[[System.String, mscorlib]], mscorlib",
                    "$values": [
                        meeting.MeetingId
                    ]
                }
            },
            "PrimaryParentIdentity": {
                "$type": "Asi.Soa.Core.DataContracts.IdentityData, Asi.Contracts",
                "EntityTypeName": "Party",
                "IdentityElements": {
                    "$type": "System.Collections.ObjectModel.Collection`1[[System.String, mscorlib]], mscorlib",
                    "$values": [
                        meeting.WorksiteId
                    ]
                }
            },
            "Properties": {
                "$type": "Asi.Soa.Core.DataContracts.GenericPropertyDataCollection, Asi.Contracts",
                "$values": [
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "ID",
                        "Value": meeting.WorksiteId
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "Ordinal",
                        "Value": meeting.MeetingId
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "VisitType",
                        "Value": "SM"
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "Note",
                        "Value": meeting.Note ? String(meeting.Note).substring(0, 21474836) : null
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "MeetingType",
                        "Value": meeting.MeetingType
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "Date",
                        "Value":  moment(meeting.MeetingDate).format('YYYY-MM-DDT00:00:00') 
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "LeadStaff",
                        "Value": meeting.OrganiserId
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "Description",
                        "Value": meeting.MeetingTitle
                    },
                ]
            }
        }
    }

    public EntityContactJson(person:any){
      return   {
            "$type": "Asi.Soa.Core.DataContracts.GenericEntityData, Asi.Contracts",
            "EntityTypeName": "i4u_UT_Contact",
            "PrimaryParentEntityTypeName": "Party",
            "Identity": {
                "$type": "Asi.Soa.Core.DataContracts.IdentityData, Asi.Contracts",
                "EntityTypeName": "i4u_UT_Contact",
                "IdentityElements": {
                    "$type": "System.Collections.ObjectModel.Collection`1[[System.String, mscorlib]], mscorlib",
                    "$values": [
                        person.id
                    ]
                }
            },
            "PrimaryParentIdentity": {
                "$type": "Asi.Soa.Core.DataContracts.IdentityData, Asi.Contracts",
                "EntityTypeName": "Party",
                "IdentityElements": {
                    "$type": "System.Collections.ObjectModel.Collection`1[[System.String, mscorlib]], mscorlib",
                    "$values": [
                        person.id
                    ]
                }
            },
            "Properties": {
                "$type": "Asi.Soa.Core.DataContracts.GenericPropertyDataCollection, Asi.Contracts",
                "$values": [
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "ID",
                        "Value":  person.id
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "ORG_CODE",
                        "Value":  person.Entity
                    }
                ]
            }
        }
    }

    public IntegrityCheckActivityJson(person: any, meeting: any) {
        return {
            "$type": "Asi.Soa.Core.DataContracts.GenericEntityData, Asi.Contracts",
            "Properties": {
                "$type": "Asi.Soa.Core.DataContracts.GenericPropertyDataCollection, Asi.Contracts",
                "$values": [
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "ID",
                        "Value": person.id
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "ACTIVITY_TYPE",
                        "Value": "INTEGRITY"
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "DESCRIPTION",
                        "Value": "Attended worksite meeting at different worksite - check worker mapping"
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "NOTE",
                        "Value": "Linked as attending meeting in different at a different worksite - " + meeting.WorkSite
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "TRANSACTION_DATE",
                        "Value": meeting.MeetingDate
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "PRODUCT_CODE",
                        "Value": "MPG"
                    },
                    {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "UF_1",
                        "Value": "N"
                    }
                ]
            }
        };
    }
}
